var $35e0614a49b3bb40$exports = {};
$35e0614a49b3bb40$exports = {
  "rangeOverflow": args => `Arvon on oltava ${args.maxValue} tai sit\xe4 aikaisempi.`,
  "rangeReversed": `Aloitusp\xe4iv\xe4n on oltava ennen lopetusp\xe4iv\xe4\xe4.`,
  "rangeUnderflow": args => `Arvon on oltava ${args.minValue} tai sit\xe4 my\xf6h\xe4isempi.`,
  "unavailableDate": `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole k\xe4ytett\xe4viss\xe4.`
};
export { $35e0614a49b3bb40$exports as default };